


























































// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { getDefaultAloPersonne } from '@/models/alo/AloPersonne'
import * as rules from '@/utils/validationRules'
import { AloFacetteType } from '@/models/alo/AloFacetteType'
import { AloFacette } from '@/models/alo/AloFacette'
import { AloFacetteFamTrad } from '@/models/alo/AloFacetteFamTrad'
import { directPayloadQuery, directQuery } from '@/utils/api'
import apiFacetteType from '@/api/facetteType'

@Component({
  name: 'GestionPersonne',  
})
export default class GestionPersonne extends Vue {

  private loading = false
  private withoutTrad = true
  private filterFacette = ""
  private facettesType:Array<AloFacetteType> = []
  private editedFacetteType:AloFacetteType|null = null
  private editedFacette :AloFacette|null= null
  private editedFacetteFam:AloFacetteFamTrad|null = null
  private newLibelle = ""
  private initialValue = ""

  
  get filteredFacettesType() {
      return this.facettesType.filter(ft =>
          (!this.withoutTrad || (ft.facettes && ft.facettes.some(f => f.facetteFamTrads && f.facetteFamTrads.some(ftr => ftr.libelle == null || ftr.libelle.length == 0)))) &&
          (
              this.filterFacette.length == 0 ||
              ft.libelle.toLowerCase().indexOf(this.filterFacette.toLowerCase()) > -1 ||
              (ft.facettes && ft.facettes.some(f =>
                  f.libelle.toLowerCase().indexOf(this.filterFacette.toLowerCase()) > -1 ||
                  (f.facetteFamTrads && f.facetteFamTrads.some(ftr =>
                      (ftr.famLibelle && ftr.famLibelle.toLowerCase().indexOf(this.filterFacette.toLowerCase()) > -1) ||
                      (ftr.libelle && ftr.libelle.toLowerCase().indexOf(this.filterFacette.toLowerCase()) > -1))
                  )
              ))
          )
      )
  }
 
  created() {   
    this.loading = true
    directQuery(apiFacetteType.getAllFacetteType,this.$store).then((facettesType)=>{
      this.facettesType = facettesType      
    }).finally(()=>{
        this.loading = false
    })
  }

  editFacetteFam(facetteType:AloFacetteType,facette:AloFacette,facetteFam:AloFacetteFamTrad) {                
      //si il n'y a pas de facette famille selectionné ou si le libelle n'a pas été modifié on peut editer 
      if (this.editedFacetteFam == null || this.newLibelle == this.initialValue) {                    
          this.editedFacetteType = facetteType
          this.editedFacette = facette
          this.editedFacetteFam = facetteFam
          this.initialValue = facetteFam.libelle && facetteFam.libelle.length > 0 ? facetteFam.libelle : (facetteFam.famLibelle + ' ' + facette.libelle)
          this.newLibelle = this.initialValue
          this.$nextTick(() => {      
              //test car la zone de text a pu etre filtré
              //@ts-ignore
              this.$refs.newLibelle[0].focus()
          })
      }
      else { //sinon on lance une alame
          if (facetteFam.key != this.editedFacetteFam.key) {
            alert("Vous aves des modifications non sauvegardées, vous devez sauvegarder ou annuler la modification sur la facette en cours d'édition avant d'en éditer une nouvelle.");
          }
      }
  }

  saveFacette(editNext=false) {
      if (this.editedFacetteFam != null) {
          //met à jour la facette
          this.editedFacetteFam!.libelle = this.newLibelle          
          //lance la sauvegarde
          directPayloadQuery(apiFacetteType.saveFacetteFamTrad,this.editedFacetteFam,this.$store).then(facetteFamTrad => {
              this.initialValue = ''
              this.newLibelle = ''

              //mise à jour de la key et l'id
              this.editedFacetteFam!.id = facetteFamTrad.id
              this.editedFacetteFam!.key = facetteFamTrad.key

              if (editNext) {
                  this.editNext()
              }
              else {
                  this.editedFacetteFam = null
              }
          })
      }
  }

  editNext(up = false) {
      if (this.editedFacetteFam == null || this.newLibelle == this.initialValue) { 
          var lastEditedFacetteFam = this.editedFacetteFam                        
          this.editedFacetteFam = null
          var offset = up ? -1 : 1
          //on recherche la prochaine facette a éditer                                        
          if (this.filteredFacettesType.length > 0) {
              var newIndexFacetteFam = this.editedFacette!.facetteFamTrads.findIndex((it) => it.key == lastEditedFacetteFam!.key) + offset
              if (newIndexFacetteFam > -1 && this.editedFacette!.facetteFamTrads.length > newIndexFacetteFam) {
                  this.editFacetteFam(this.editedFacetteType!, this.editedFacette!, this.editedFacette!.facetteFamTrads[newIndexFacetteFam])
              }
              else {
                  var newIndexFacette = this.editedFacetteType!.facettes.findIndex((it) => it.id == this.editedFacette!.id) + offset
                  if (newIndexFacette > -1 && this.editedFacetteType!.facettes.length > newIndexFacette) {
                      newIndexFacetteFam = up ? this.editedFacetteType!.facettes[newIndexFacette].facetteFamTrads.length - 1 : 0
                      this.editFacetteFam(this.editedFacetteType!, this.editedFacetteType!.facettes[newIndexFacette], this.editedFacetteType!.facettes[newIndexFacette].facetteFamTrads[newIndexFacetteFam])
                  }
                  else {
                      var indexFacetteType = this.filteredFacettesType.findIndex((it) => it.id == this.editedFacetteType!.id)
                      var newIndexFacetteType = indexFacetteType + offset
                      if (indexFacetteType <= -1 || newIndexFacetteType <= -1 || this.filteredFacettesType.length <= newIndexFacetteType) {
                          newIndexFacetteType = up ? this.filteredFacettesType.length - 1 : 0
                      }
                      newIndexFacette = up ? this.filteredFacettesType[newIndexFacetteType].facettes.length - 1 : 0
                      newIndexFacetteFam = up ? this.filteredFacettesType[newIndexFacetteType].facettes[newIndexFacette].facetteFamTrads.length - 1 : 0
                      this.editFacetteFam(this.filteredFacettesType[newIndexFacetteType], this.filteredFacettesType[newIndexFacetteType].facettes[newIndexFacette], this.filteredFacettesType[newIndexFacetteType].facettes[newIndexFacette].facetteFamTrads[newIndexFacetteFam])
                  }
              }
          }
          else {
              this.editedFacetteType = null
              this.editedFacette = null
              this.editedFacetteFam = null
          }
      }
      else { //sinon on lance une alame                    
          alert("Vous avez des modifications non sauvegardées, vous devez sauvegarder ou annuler la modification sur la facette en cours d'édition avant d'en éditer une nouvelle.");                    
      }

  }

  cancelFacette() {                
      if (this.editedFacetteFam != null) {                    
          this.newLibelle = ''
          this.editedFacetteFam = null                    
      }
  }
 
}
